import React, {useEffect, useRef} from "react";
import {useRenderableData} from "./hooks/useRenderableData";

export let ExpandingPillButtonSection = function (props) {
    const buttonTextRef = useRef(null);
    let renderableData = useRenderableData({
        showContent: true,
        buttonWidth: 'fit-content'
    })

    useEffect(() => {
        renderableData.updateAndRender({
            buttonWidth: (
                buttonTextRef.current.offsetWidth +
                80 // icon width (20px) + padding (20px) on both sides + gap (20px)
            )
        })
    }, [])


    let containerClasses = props.containerClasses || ''
    let expandedClass = renderableData.showContent ? 'expanded' : ''

    function onClickToggleButton() {
        renderableData.updateAndRender({showContent: !renderableData.showContent})
    }

    return (
        <div
            className={`expanding-pill-button-section ${containerClasses} ${expandedClass}`}
            style={{
                maxWidth: renderableData.buttonWidth
            }}
        >
            <div className="pill-button-container expanding-pill-button-container">
                <div
                    className="pill-button"
                    onClick={onClickToggleButton}
                >
                    <div className="pill-button-content">
                        <div className="pill-button-text-section">
                            <div
                                ref={buttonTextRef}
                                className="pill-button-text"
                            >{props.buttonText}</div>
                        </div>
                        <svg
                            className="expanding-pill-button-section-icon"
                            viewBox="0 0 436.68649 265.01041"
                            width="436.68649"
                            height="265.01041"
                        >
                            <path
                                fill="#fff"
                                d="M 201.37275,257.98152 7.02975,63.637517 c -9.373,-9.373 -9.373,-24.569 0,-33.941 l 22.667,-22.6670001 c 9.357,-9.357 24.522,-9.375 33.901,-0.04 L 218.34375,161.01052 373.08875,6.9895169 c 9.379,-9.335 24.544,-9.317 33.901,0.04 l 22.667,22.6670001 c 9.373,9.373 9.373,24.569 0,33.941 l -194.343,194.343003 c -9.372,9.373 -24.568,9.373 -33.941,10e-4 z"
                            />
                        </svg>
                    </div>
                </div>
            </div>
            <div className="expanding-content">
                {props.expandingContentRenderer()}
            </div>
        </div>
    );
};
